__webpack_require__.p = "https://avalon.bgsu.edu/packs/";